import { select as d3Select } from "d3-selection";
import { zoom as d3Zoom } from "d3-zoom";
import { useEffect } from "react";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ZoomX = _ref => {
  let {
    surface,
    scaleExtent,
    translateExtent,
    initialScale,
    onZoom,
    children
  } = _ref;
  useEffect(() => {
    const zoom = d3Zoom().scaleExtent(scaleExtent).translateExtent(translateExtent).on("zoom", event => {
      onZoom(event.transform.rescaleX(initialScale));
    });
    const selection = d3Select(surface);
    selection.call(zoom);
    return () => {
      selection.on(".zoom", null);
    };
  }, [initialScale, onZoom, scaleExtent, surface, translateExtent]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
ZoomX.displayName = "ZoomX";
export default ZoomX;